import React from 'react';
import { ZapIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
interface CtaButtonProps {
  label: string;
  subLabel?: string;
  href?: string;
  className?: string;
  size?: 'default' | 'compact';
}
const SCROLL_DURATION_MS = 1400;
export function CtaButton({
  label,
  subLabel,
  href = CHECKOUT_URL,
  className = '',
  size = 'default'
}: CtaButtonProps) {
  const isInternal = href.startsWith('#');
  const isCompact = size === 'compact';
  const verticalPadding = isCompact ? '12px' : '18px';
  const labelFontSize = isCompact ? '15px' : '20px';
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isInternal) return;
    const target = document.querySelector<HTMLElement>(href);
    if (!target) return;
    event.preventDefault();
    smoothScrollTo(target);
    window.history.replaceState(null, '', href);
  };
  return <a href={href} onClick={handleClick} target={isInternal ? undefined : '_blank'} rel={isInternal ? undefined : 'noopener noreferrer'} className={`inline-flex flex-col items-center justify-center rounded-lg bg-orange-500 px-6 py-4 text-center text-slate-950 shadow-lg shadow-orange-500/40 ring-4 ring-orange-500/15 transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-orange-500 active:translate-y-0 ${className}`} style={{
    paddingTop: verticalPadding,
    paddingBottom: verticalPadding
  }} data-id="element-28" data-mp="159gf6rmemq0q">
      <span className="flex items-center justify-center gap-2 text-balance font-black uppercase leading-tight tracking-wide" style={{
      fontSize: labelFontSize
    }} data-id="element-29" data-mp="3swka3vvc326w">
        <ZapIcon className={`${isCompact ? 'h-4 w-4' : 'h-5 w-5'} shrink-0 fill-slate-950`} aria-hidden="true" data-id="element-30" data-mp="6hrfh3b48u7x" />
        {label}
      </span>
      {subLabel && <span className="mt-1 text-[0.72rem] font-bold uppercase tracking-[0.18em] text-slate-950/70" data-id="element-31" data-mp="biorsz9g2u1i">
          {subLabel}
        </span>}
    </a>;
}
function smoothScrollTo(target: HTMLElement) {
  const endY = target.getBoundingClientRect().top + window.scrollY;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) {
    window.scrollTo(0, endY);
    return;
  }
  const startY = window.scrollY;
  const distance = endY - startY;
  const startTime = performance.now();
  const step = (now: number) => {
    const progress = Math.min((now - startTime) / SCROLL_DURATION_MS, 1);
    window.scrollTo(0, startY + distance * easeInOutCubic(progress));
    if (progress < 1) window.requestAnimationFrame(step);
  };
  window.requestAnimationFrame(step);
}
function easeInOutCubic(t: number) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}